import { FC, Fragment } from 'react';
import {
  FlightDetails as FlightType,
  FlightDetailsResponse,
  Outbound,
} from 'ts/flight/interfaces/FlightDetailsResponse';
import OrderDetails from './OrderDetails';
import TicketDetails from './TicketDetails';
import FlexDetails from './FlexDetails';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface FlightDetailsProps {
  flexOrFlight?: FlightType;
  bounds: Outbound[];
  response?: FlightDetailsResponse;
  flexFlightId: string;
  setFlexFlightId: (id: string) => void;

  listFlexFlights?: FlightType[];
  googleMapOfAirports?: string;
  searchToken: string;
}

const FlightDetails: FC<FlightDetailsProps> = ({
  flexOrFlight,
  setFlexFlightId,
  response,
  bounds,
  listFlexFlights,
  googleMapOfAirports,
  searchToken,
  ...props
}) => {
  return (
    <Fragment>
      {!!flexOrFlight && !response?.hasErrors && !response?.sessionExpired && (
        <Fragment>
          <OrderDetails
            flight={flexOrFlight}
            bounds={bounds}
            mapUrl={'https:' + googleMapOfAirports}
            searchToken={searchToken}
          />

          {bounds.map((bound, index) => (
            <TicketDetails
              type={bound.flightType}
              bound={bound}
              key={index}
              flightSource={flexOrFlight.flightSource}
            />
          ))}

          {!!listFlexFlights?.length && (
            <FlexDetails
              flexFlights={listFlexFlights}
              onChooseFlex={(id) => setFlexFlightId(id)}
              flexFlightId={props.flexFlightId}
            />
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default withErrorBoundary(FlightDetails, 'FlightDetails');
